import { ReactComponent as admin } from "./admin.svg";
import { ReactComponent as black_list } from "./black_list.svg";
import { ReactComponent as list } from "./list.svg";
import { ReactComponent as plus } from "./plus.svg";
import { ReactComponent as superAdmin } from "./SuperAdmin.svg";
import { ReactComponent as users } from "./User.svg";
import { ReactComponent as log } from "./UserLog.svg";
import { ReactComponent as SvgClock } from "./SvgClock.svg";
import { ReactComponent as earth } from "./earth.svg";
import { ReactComponent as envelop } from "./envelop.svg";
import { ReactComponent as key } from "./key.svg";
import { ReactComponent as formUser } from "./formUser.svg";
import { ReactComponent as location } from "./location.svg";
import { ReactComponent as company } from "./company.svg";
import { ReactComponent as formUsers } from "./users.svg";
import { ReactComponent as phone } from "./phone.svg";
import { ReactComponent as card } from "./card.svg";
import { ReactComponent as Edit } from "./Edit.svg";
import { ReactComponent as bin } from "./bin.svg";
import { ReactComponent as importIcon } from "./import.svg";
import { ReactComponent as exportIcon } from "./export.svg";
import { ReactComponent as accountIcon } from "./account.svg";
import { ReactComponent as signOut } from "./signOut.svg";
import { ReactComponent as profile } from "./profile.svg";
import { ReactComponent as passkey } from "./passKey.svg";
import { ReactComponent as sendEmail } from "./sendEmail.svg";
import { ReactComponent as view } from "./view.svg";

export const SvgAdmin = admin;
export const SvgList = list;
export const SvgBlackList = black_list;
export const SvgPlus = plus;
export const SvgSuperAdmin = superAdmin;
export const SvgUsers = users;
export const SvgUserLog = log;
export const SVGClock = SvgClock;
export const SvgEarth = earth;
export const SvgEnvelop = envelop;
export const SvgKey = key;
export const SvgFormUser = formUser;
export const SvgLocation = location;
export const SvgCompany = company;
export const SvgFormUsers = formUsers;
export const SvgPhone = phone;
export const SvgCard = card;
export const SvgEdit = Edit;
export const SvgBin = bin;
export const SvgImport = importIcon;
export const SvgExport = exportIcon;
export const SvgAccount = accountIcon;
export const SvgSignOut = signOut;
export const SvgProfile = profile;
export const SvgChangePasswordKey = passkey;
export const SvgSendEmail = sendEmail;
export const SvgView = view;